<template>
	<div
		class="kk-radio-button-group"
		role="radiogroup"
		v-bind="$attrs"
	>
		<slot></slot>
	</div>
</template>

<script>
import { RADIO_BUTTON_ITEM_SIZE_LIST } from '../../KkRadioButtonItem';

export default {
	name: 'KkRadioButtonGroup',
	props: {
		value: {
			type: [String, Number, Boolean],
			default: null,
		},
		size: {
			type: String,
			default: 'md',
			validator: val => RADIO_BUTTON_ITEM_SIZE_LIST.includes(val),
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
	},
	created() {
		this.$on('input', value => {
			this.$emit('change', value);
		});
	},
};
</script>
